import { useMemo, useState } from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Box, TextField, Button } from '@mui/material';
import { useLocales } from 'src/locales';
import { useSearchParams } from 'react-router-dom';


export default function EidpForm() {
  const { t } = useLocales();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState<string>(''); 


  const { error, reason } = useMemo(() => {
    if (searchParams.has("error")) {
      return { error: searchParams.get("error"), reason: searchParams.has("reason") ? searchParams.get("reason") : null }
    }
    return { error: null, reason: null }
  }, [searchParams])

  return (
    <div style={{
      width: '100%', height: '100vh',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      backgroundImage: 'url(/assets/background/background.jpg)',
      backgroundSize: 'cover', backgroundPosition: 'center'
    }}>
      <div style={{
        width: '100%', maxWidth: '400px',
        backgroundColor: 'white', borderRadius: '10px', padding: '40px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
      }}>
        <Box>
          <Stack spacing={2} sx={{ mb: 3 }}>
            <Typography variant="h4" align="center" color="#1C252E">
              Enterprise connection
            </Typography>
          </Stack>
          <Stack spacing={2}>
            {!!error && <Alert severity="error">{t('auth.form.signin.error.' + error + '.' + reason)}</Alert>}
            <TextField
              fullWidth
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              name="email"
              label={t('auth.form.signin.Email')}
              InputLabelProps={{ sx: { color: '#1C252E', '&.Mui-focused': { color: '#1C252E' } } }}
              InputProps={{ sx: { color: '#1C252E' } }}
            />
            <Button
              fullWidth
              variant="contained"
              sx={{ backgroundColor: '#1C252E', color: 'white' }}
              onClick={() => {
                window.location.href = (process.env.CROSS_API_URL + `/auth/eidp?email=${email}`);
              }}
            >
              Login
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                window.location.href = '/auth/signin';
              }}
            >
              Back to login options
            </Button>
          </Stack>
        </Box>
      </div>
    </div>
  );
}
